module.exports = __webpack_public_path__ + "img/table.f82b11e7.png";